import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Applicant } from 'src/app/models/applicant.model';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'gabarito-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  name: string;
  isAdmin = false;
  isApplicant = false;
  dashboardActive = false;
  cersActive = false;
  officalActive = false;
  templateActive = false;


  IsOAB = true;

  

  themeStorage = localStorage.getItem('darkThema');      
  setThemaStorage =  localStorage.setItem('lightThema', 'true');
  lightThemeStorage = localStorage.getItem('lightThema');  
  setThemaLightFalse =  localStorage.setItem('lightThema', 'false');


  elementBody = document.querySelector("body");


  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {

    if(this.isAdmin){
      this.setThemaLightFalse;
    }else{
      this.setThemaStorage
    }

    let elementBody = document.querySelector("body");
    if (this.isApplicant ) {
      this.setThemaStorage;
      this.elementBody.classList.remove("activate-theme");
    }
   
    if(this.themeStorage == 'true'){
      elementBody.classList.add('activate-theme');
    }else{
      elementBody.classList.remove('activate-theme');
    }

    
    if (this.router.url.startsWith('/applicant')) {
      const applicant = this.authService.getLoggedApplicant();
      this.name = applicant.name.split(' ')[0];
      elementBody.classList.remove('activate-theme');
      this.isApplicant = true;

    } else if (this.router.url.startsWith('/employee')) {
      const employee = this.authService.getLoggedEmployee();
      this.name = employee.username.split(' ')[0];
      elementBody.classList.remove('activate-theme');
      this.isAdmin = this.authService.isEmployeeAdmin();
      if (this.isAdmin) {
        if (this.router.url.includes('dashboard')) {
          this.dashboardActive = true;
          this.cersActive = false;
          this.officalActive = false;
          this.templateActive = false;
        } else if (this.router.url.includes('associate-question')) {
          this.templateActive = false;
          this.dashboardActive = false;
          this.cersActive = true;
          this.officalActive = false;
        } else if (this.router.url.includes('official-answer')) {
          this.templateActive = false;
          this.dashboardActive = false;
          this.cersActive = false;
          this.officalActive = true;
        } else if (this.router.url.includes('template')) {
          this.templateActive = true;
          this.dashboardActive = false;
          this.cersActive = false;
          this.officalActive = false;
        }
      }
    }

    this.activateTema()

  }
  

  logout() {
    if (this.router.url.startsWith('/applicant')) {
      this.authService.applicantLogout();
      this.router.navigate(['/login']);
    } else if (this.router.url.startsWith('/employee')) {
      this.authService.employeeLogout();
      this.router.navigate(['/login-professor']);
    }
  }

  official() {
    this.router.navigate(['/employee/official-answer']);
    this.dashboardActive = false;
    this.cersActive = false;
    this.officalActive = true;
    this.templateActive = false;
  }

  cers() {
    this.router.navigate(['/employee/associate-question']);
    this.dashboardActive = false;
    this.cersActive = true;
    this.officalActive = false;
    this.templateActive = false;
  }

  dashboard() {
    this.router.navigate(['/employee/dashboard']);
    this.dashboardActive = true;
    this.cersActive = false;
    this.officalActive = false;
    this.templateActive = false;
  }

  template() {
    this.router.navigate(['/employee/template-list']);
    this.templateActive = true;
    this.dashboardActive = false;
    this.cersActive = false;
    this.officalActive = false;
  }

  templateApplicant() {
    this.router.navigate(['/applicant/template/view']);
  }

  redirectTemplate() {
    if (this.isApplicant) {
      this.router.navigate(['/applicant/template/view']);
    } else if (this.isAdmin) {
      this.router.navigate(['/employee/template-list']);
    }
  }
  

    




    activateTema() {
        let elementBody = document.querySelector("body");
        let elementoAtivo = document.querySelector<HTMLInputElement>('.switch--shadow').checked;
      
        if(elementoAtivo == true){
          localStorage.setItem('darkThema', 'true');
          elementBody.classList.add("activate-theme");
        }else{
          localStorage.setItem('darkThema', 'false');
          elementBody.classList.remove("activate-theme");
        }
    }
  
  

  


}
